import eventEmitter from './eventemitter';
import {debounce} from '../../../utils/debounce';

export const CLEAR = 'clear';
export const PRODUCT_ADDED = 'product-added';
export const PRODUCT_REMOVED = 'product-removed';
export const PRODUCT_COMPARE_REQUEST = 'product-compare-request';

export default function compareBar($container, products) {
    const emitter = eventEmitter();
    const $clear = $container.querySelector('#clearClose');
    const $compare = $container.querySelector('#compareButton');
    const $list = $container.querySelector('#thumbList');
    const $listItem = $list.querySelector('li').cloneNode(true);
    const $msgBox = $container.querySelector('#msgBox');
    let initialized = false;

    const show = () => {
        $container.style.display = 'block';

        if (!initialized) {
            if (window.matchMedia('screen and (max-width: 768px)').matches) {
                const millisecondDelay = 100;

                window.addEventListener('scroll', debounce(fixElementOnScroll($container), millisecondDelay));
            }

            initialized = true;
        }
    };

    const hide = () => ($container.style.display = 'none');

    const enable = () => ($compare.disabled = false);

    const disable = () => ($compare.disabled = true);

    const add = product => {
        const $availableListItem = $list.querySelector('.cell:not(.lit)');

        if (!$availableListItem) {
            return;
        }

        const $img = $availableListItem.querySelector('img');
        const $close = $availableListItem.querySelector('a');

        $availableListItem.classList.add('lit');
        $availableListItem.dataset.id = product.id;
        $availableListItem.tabIndex = 0;
        $img.src = `${product.img}?width=26`;
        $img.alt = product.name;
        $img.style.opacity = 1;

        emitter.emit(PRODUCT_ADDED, product);

        $availableListItem.addEventListener('mouseenter', event => {
            if (event.currentTarget.classList.contains('lit')) {
                addMessage(event.currentTarget.firstElementChild.alt);
            }
        });

        $availableListItem.addEventListener('mouseleave', event => {
            if (event.currentTarget.classList.contains('lit')) {
                removeMessage();
            }
        });

        const fixOddFocusLockOnUI = target => target.blur();

        $availableListItem.addEventListener('click', event => fixOddFocusLockOnUI(event.currentTarget));

        $close.addEventListener('click', event => {
            event.preventDefault();
            emitter.emit(PRODUCT_REMOVED, product);
            remove(product);
        });
    };

    const remove = product => {
        const $items = Array.from($list.querySelectorAll('.lit'));
        if (!$items.length) {
            return;
        }

        const index = $items.findIndex($item => +$item.dataset.id === +product.id);

        if (index === -1) {
            return;
        }

        removeMessage();
        $list.removeChild($items[index]);
        $list.appendChild($listItem.cloneNode(true));
    };

    const addMessage = alt => ($msgBox.innerHTML = alt);

    const removeMessage = () => ($msgBox.innerHTML = '');

    $compare.addEventListener('click', event => {
        event.preventDefault();
        emitter.emit(PRODUCT_COMPARE_REQUEST);
    });

    $clear.addEventListener('click', event => {
        event.preventDefault();
        emitter.emit(CLEAR);

        Array.from($list.querySelectorAll('.lit')).forEach($item => {
            $item.parentElement.replaceChild($listItem.cloneNode(true), $item);
        });

        hide();
    });

    if ((products || []).length) {
        products.forEach(product => add(product));
        show();
    }

    return {
        ...emitter,
        show,
        hide,
        add,
        remove,
        enable,
        disable
    };
}

function fixElementOnScroll($element) {
    let elementOffsetTop = $element.offsetTop;

    return () => {
        const hasScrolledPastElementPosition = document.documentElement.scrollTop > elementOffsetTop;
        $element.classList[hasScrolledPastElementPosition ? 'add' : 'remove']('fixed');
    };
}
